import AxiosInstance from "../Utils/axios/axiosConfig";

export const getProductsData = async (params) => {
  let response;
  if (params) {
    if (params.page && params.size && params.sort_by && params.sort_type) {
      const start = (params.page - 1) * params.size;
      const end = start + params.size * 1;
      response = await AxiosInstance.get(
        `/products/?sort_by=${params.sort_by}&sort_type=${params.sort_type}&start=${start}&end=${end}`
      );
    } else if (params.status)
      response = await AxiosInstance.get(`/products/?status=${params.status}`);
  } else response = await AxiosInstance.get("/products/");

  if (!response.data.error) {
    return response.data.data;
  } else {
    return Promise.reject(response);
  }
};

export const getProducts = async (params) => {
  let response;
  if (params) {
    // if (params.page && params.size && params.sort_by && params.sort_type) {
    //   const start = (params.page - 1) * params.size;
    //   const end = start + params.size * 1;
    //   response = await AxiosInstance.get(
    //     `/products/?sort_by=${params.sort_by}&sort_type=${params.sort_type}&start=${start}&end=${end}`
    //   );
    // } else if (params.status)
    if(params.status) {
      if(params.isPly){
      response = await AxiosInstance.get(`/crud/products/?type=${params.type}&ply=${params.ply}&dropdown`);
      }
      else{
        response = await AxiosInstance.get(`/products/?status=${params.status}&dropdown`);
      }
    }
  } else response = await AxiosInstance.get("/products/");

  if (!response.data.error) {
    return response.data.data;
  } else {
    return Promise.reject(response);
  }
};

export const getProductsDataForConfiguration = async (params) => {
  let response;
  if (params) {
    if (params.page && params.size && params.sort_by && params.sort_type) {
      const start = (params.page - 1) * params.size;
      const end = start + params.size * 1;
      response = await AxiosInstance.get(
        `/crud/products/?sort_by=${params.sort_by}&sort_type=${params.sort_type}&start=${start}&end=${end}`
      );
    } else if (params.status)
      response = await AxiosInstance.get(`/crud/products/?status=${params.status}`);
  } else response = await AxiosInstance.get("/crud/products/");

  if (!response.data.error) {
    return response.data.data;
  } else {
    return Promise.reject(response);
  }
};

export const getProductsForMerging = async (isEnabled = false, grade, quality) => {
  let response;
  if(isEnabled){
    response = await AxiosInstance.get(`/products/`);
  } else{
    response = await AxiosInstance.get(`/products/?grade=${grade}&quality=${quality}`);
  }
  if (!response.data.error) {
    return response.data.data;
  } else {
    return Promise.reject(response);
  }
};
export const getProductDetails = async (code = "") => {
  const response = await AxiosInstance.get("/products/", {
    params: { code: code },
  });
  if (!response.data.error) {
    return response.data;
  } else {
    return Promise.reject(response.message);
  }
};

export const fetchProductDetails = async (body = {}) => {
  const response = await AxiosInstance.post(`/crud/products/?get`, body);
  return response.data.data;
};

export const editProduct = async (code, body = {}) => {
  const response = await AxiosInstance.put(`/crud/products/?code=${code}`, body);
  return response.data.data;
};

export const addProduct = async (body = {}) => {
  const response = await AxiosInstance.post(`/crud/products/`, body);
  return response.data;
};

export const deleteProduct = async (code) => {
  const response = await AxiosInstance.delete(`/crud/products/?code=${code}`);
  return response.data;
};

// Search products
export const searchProducts = async (pattern = "", params = {}, source = undefined) => {
  const start = (params.page - 1) * params.size;
  const end = start + params.size * 1;
  let response;
  if(!params.size && !params.page){
    response = await AxiosInstance.get("/crud/products/?search", {
      params: {
        type: "contains",
        pattern: pattern,
        sort_by: params.sort_by,
        sort_type: params.sort_type,
      },
    });
  } else{
    if(source){
      response = await AxiosInstance.get("/crud/products/?search", {
        params: {
          type: "contains",
          pattern: pattern,
          sort_by: params.sort_by,
          sort_type: params.sort_type,
          start: start,
          end: end,
        },
        cancelToken: source?.token
      });
    } else{
      response = await AxiosInstance.get("/crud/products/?search", {
        params: {
          type: "contains",
          pattern: pattern,
          sort_by: params.sort_by,
          sort_type: params.sort_type,
          start: start,
          end: end,
        },
      });
    }    
  }
  if (!response.data.error) {
    return response.data.data;
  } else {
    return Promise.reject(response);
  }
};

export const getFilteredProducts = async (sortParams, filter, source = undefined, searchedValue) => {
  let response;

  // Build base URL
  let url = `/crud/products/filter/`;

  // Add search params if provided
  if (searchedValue) {
    url += `?search&type=contains&pattern=${encodeURIComponent(searchedValue)}`;
  } else {
    url += `?`;
  }

  // Add sorting + pagination if available
  if (sortParams) {
    const start = (sortParams.page - 1) * sortParams.size;
    const end = start + sortParams.size;
    url += `&sort_by=${sortParams.sort_by}&sort_type=${sortParams.sort_type}&start=${start}&end=${end}`;
  }

  // API call with optional cancel token
  if (source) {
    response = await AxiosInstance.post(url, filter, { cancelToken: source?.token });
  } else {
    response = await AxiosInstance.post(url, filter);
  }

  // Handle API response
  if (!response.data.error) {
    return response.data;
  } else {
    return Promise.reject(response);
  }
};


export const getProductDetailsForSelectedOrders = async (params) => {
  const response = await AxiosInstance.put(`/products/bulk-gsm-only/`, params);
  return response.data.data;
};

export const addStockSize = async (body = {}) => {
  const response = await AxiosInstance.post('/crud/products/stock-sizes/', body);
  return response.data;
};

export const getStockSizes = async (productCode) => {
  const response = await AxiosInstance.get(`/crud/products/stock-sizes/?code=${productCode}`);
  return response.data;
};

export const deleteStockSize = async (stockSizeId) => {
  const response = await AxiosInstance.delete(`/crud/products/stock-sizes/?id=${stockSizeId}`);
  return response.data;
};

export const editStockSize = async (productCode, id, body = {}) => {
  const response = await AxiosInstance.put(`/crud/products/stock-sizes/?code=${productCode}&id=${id}`, body);
  return response.data;
};

export const getPendingQuantityProductSizes = async (productCode, body = {}) => {
  const response = await AxiosInstance.get(`/jobcards/machine-selection/product-stock-sizes/?code=${productCode}`, body);
  return response.data;
};

export const getPendingQuantityProductSizesByPly = async (productCode, ply,body = {}) => {
  const response = await AxiosInstance.get(`/jobcards/machine-selection/product-stock-sizes/?code=${productCode}&ply=${ply}`, body);
  return response.data;
};

export const getStockSizesDetailsByIds = async (body = {}) => {
  const response = await AxiosInstance.post(`/crud/products/stock-sizes/?get`, body);
  return response.data;
};

export const getStocksDetailsByIds = async (body = {}) => {
  const response = await AxiosInstance.post(`/inventory/stocks/?get`, body);
  return response.data;
};

export const getProductHistoryById = async (code,sort) => {
  const start = (sort.page - 1) * sort.size;
  const end = start + sort.size * 1;
  const response = await AxiosInstance.get(`/products/history/?code=${code}&start=${start}&end=${end}`);
  if (!response.data.error) {
    return response.data;
  } else {
    return Promise.reject(response);
  }
};

// Change History Search
export const searchProductHistory = async (code, pattern) => {
  const response = await AxiosInstance.get(
    `/products/history/?code=${code}&search&type=contains&pattern=${pattern}`
    );
  if (!response.data.error) {
    return response.data.data;
  } else {
    return Promise.reject(response);
  }
};

// Product Stock Search
export const searchProductStock = async (code, pattern) => {
  const response = await AxiosInstance.get(
    `/crud/products/stock-sizes/?search&code=${code}&type=contains&pattern=${pattern}`
    );
  if (!response.data.error) {
    return response.data.data;
  } else {
    return Promise.reject(response);
  }
};

export const fetchWorkFlowProductDetails = async (body = {}) => {
  const response = await AxiosInstance.post(`/products/workflow/?get`, body);
  return response.data.data;
};